import React, { useState } from "react";
import styled from "styled-components";
import TotalsByRep from "./Trials/totalsByRep";
import TotalsByRepWithRegion from "./Trials/totalsByRepWithRegion";

function TrialByRepExplorer() {
  const [searchBy, setSearchBy] = useState("dd"); // 'week' or 'dd'
  const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
  const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";

  const handleChangeTimeFrame = () => {
    setSearchBy(searchBy === "dd" ? "week" : "dd");
  };

  return (
    <Container>
      <h1>
        Total Trials by representation
      </h1>
      <div>
        <label>Current Time Frame:</label>&nbsp;
        <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
        <button onClick={handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
      </div>
      <br />
      <h2>{currentDateLabel} by Representation</h2>
      <TotalsByRep date={searchBy} />
      <hr />

      <br />
      <h2>{currentDateLabel} by Representation with region</h2>
      <TotalsByRepWithRegion date={searchBy} />
      <hr />
    </Container>
  );
}

const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default TrialByRepExplorer